var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.13 36.67"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "upload")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.34,23.12,24,18.43l-.12-.09a2.11,2.11,0,0,0-.23-.19L23.42,18l-.13-.07a.61.61,0,0,0-.13,0l-.31-.07-.28,0-.3,0-.29.07-.14,0a.57.57,0,0,0-.13.08,1.35,1.35,0,0,0-.26.15,1.12,1.12,0,0,0-.24.19l-.12.09L16.8,23.12a2,2,0,1,0,2.95,2.7l.82-.89v9.44a2,2,0,0,0,4,0V24.93l.82.89a2,2,0,1,0,2.95-2.7Z",
    fill: "#3772b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,15.11c0-2.65-.57-7.51-3.74-11C30.34,1.37,26.9,0,22.57,0S14.8,1.37,12.37,4.08c-3.16,3.52-3.7,8.38-3.73,11C4.91,16,0,19,0,26a9.9,9.9,0,0,0,3.43,8.07c4.67,3.82,12.32,2.33,12.64,2.26a2,2,0,0,0-.79-3.92c-.06,0-6.15,1.15-9.31-1.44a6,6,0,0,1-2-5c0-6.47,6.15-7.16,6.84-7.21a2,2,0,0,0,1.85-2.21c0-.06-.61-6.21,2.67-9.84C17,4.92,19.42,4,22.57,4s5.57.92,7.21,2.74c3.27,3.63,2.68,9.78,2.67,9.84a2,2,0,0,0,.45,1.49,2,2,0,0,0,1.39.72c.28,0,6.84.56,6.84,7.21a6,6,0,0,1-2,5c-2.64,2.17-7.62,1.78-9.31,1.44a2,2,0,0,0-.8,3.92,21.23,21.23,0,0,0,3.87.34c2.67,0,6.18-.48,8.77-2.6C44,32.2,45.13,29.49,45.13,26,45.13,19,40.22,16,36.5,15.11Z",
    fill: "#3772b9"
  })))));
}

export default SvgUpload;